export default "__VITE_ASSET__CFkEboKy__"